import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { Redirect, Route, Switch } from "wouter";
import { CreateView } from "./create/create.view";
import { DepartmentView } from "./department.view";
import { UpdateView } from "./update/update.view";

export function DepartmentRoutes() {
  const ability = useAbility();
  const departmentUuidRegex = generateUuidV4Regex({ paramName: "uuid", suffix: "/update" });
  const canManage = ability.can(Action.Manage, "Department");

  return (
    <Switch>
      <Route path={"/"} component={DepartmentView} />
      <Route path={"/create"} component={canManage ? CreateView : ReadOnlyRedirect} />
      <Route path={departmentUuidRegex} component={canManage ? UpdateView : ReadOnlyRedirect} />
      <Route component={NotFoundView} />
    </Switch>
  );
}

function ReadOnlyRedirect() {
  return <Redirect to="/" replace />;
}
